import { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // בדוק אם המשתמש כבר הסכים ל-Cookies
    const hasConsented = localStorage.getItem('cookieConsent');
    if (!hasConsented) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setShowConsent(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'false');
    setShowConsent(false);
  };

  if (!showConsent) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-[#1a1a1a] to-[#2a2a2a] border-t border-[#3a3a3a] p-4 z-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-[#9B8A61] mb-2">
              🍪 שימוש ב-Cookies
            </h3>
            <p className="text-gray-300 text-sm">
              אנו משתמשים ב-Cookies כדי לשפר את חוויית המשתמש שלכם באתר.
              המשך השימוש באתר מהווה הסכמה לשימוש ב-Cookies.
              <a href="/privacy-policy" className="text-[#D4AF37] hover:underline ml-1">
                קרא עוד
              </a>
            </p>
          </div>
          <div className="flex gap-3">
            <button
              onClick={handleDecline}
              className="px-4 py-2 text-gray-300 hover:text-white transition-colors text-sm"
            >
              דחה
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-2 bg-gradient-to-r from-[#9B8A61] to-[#D4AF37] text-white rounded-lg hover:from-[#8A7A51] hover:to-[#C4A027] transition-all duration-300 text-sm font-medium"
            >
              קבל
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent; 